import ic from 'assets/icons/stacked-bar-chart.svg';
import React, {Component, PureComponent} from 'react';
import {Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import './OpexStructure.style.scss';

export default class OpexStructure extends Component {
  render() {
    const data = [
      {
        name: 'Staff cost',
        value: 50,
      },
      {
        name: 'Admin cost',
        value: 70,
      },
      {
        name: 'Asset cost',
        value: 50,
      },
      {
        name: 'Others',
        value: 30,
      },
      {
        name: 'Total cost',
        value: 100,
      },
    ].map((item) => ({...item, remainingvalue: 100 - item.value, total: 100}));
    return (
      <div className='opex-container'>
        <h1 className='title'>
          <img src={ic} alt='' style={{marginRight: 8}} />
          OPEX STRUCTURE
        </h1>
        <ResponsiveContainer width='100%' height={300}>
          <BarChart data={data} layout='vertical'>
            <Tooltip cursor={false} content={<CustomTooltip />} />

            <XAxis type='number' hide />
            <YAxis
              type='category'
              dataKey='name'
              width={100}
              axisLine={false}
              tickLine={false}
              tick={<CustomizedAxisTick />}
            />

            <Bar dataKey='value' stackId='a'>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill='#FBC83A'
                  strokeWidth={2}
                  stroke='white'
                  height={50}
                  radius={8}
                />
              ))}
            </Bar>
            <Bar dataKey='remainingvalue' stackId='a'>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill='#EBEBEB'
                  strokeWidth={2}
                  stroke='white'
                  height={50}
                  radius={8}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

class CustomizedAxisTick extends PureComponent {
  render() {
    const {x, y, payload} = this.props;

    return (
      <text
        x={x - 16}
        y={y - 14}
        dy={24}
        fill='#0B0B0A'
        verticalAnchor='middle'
        textAnchor='end'
        fontSize={14}>
        <tspan>{payload.value}</tspan>
      </text>
    );
  }
}

const CustomTooltip = (props) => {
  const {active, payload} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;

    return (
      <div className='custom-tooltip'>
        <div className='name'>{item.name}</div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#fbc83a'}} />
          <div className='desc'>{item.value}</div>
        </div>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/OpexStructure/OpexStructure.js